'use strict';

var Sugar = require('sugar-core'),
    getRegExpFlags = require('../common/internal/getRegExpFlags');

Sugar.RegExp.defineInstance({

  'getFlags': function(r) {
    return getRegExpFlags(r);
  }

});

module.exports = Sugar.RegExp.getFlags;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/regexp/getFlags.js
// module id = 880
// module chunks = 0